/**
 * Browser IANA timezone (no permission prompt — unlike geolocation).
 */
export function getBrowserTimezone(): string | undefined {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return tz && tz.trim() ? tz.trim() : undefined;
  } catch {
    return undefined;
  }
}
